import classNames from 'clsx';
import React from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';
import { isRunning } from '@swf/core/utils/casino';

import Cup from '../../assets/leaderboard.svg';
import PlayButton from '../PlayButton/PlayButton';
import RegisteredPlayers from '../RegisteredPlayers/RegisteredPlayers';

import styles from './PlayBar.scss';

export interface Props {
  race: CasinoRace;
  onLaunch(): void;
  onLeaderboard?(): void;
}

const PlayBar: React.FC<Props> = ({ onLeaderboard, race, onLaunch }) => {
  const { numOfPlayers, status } = race;
  const isLiveRace = isRunning(status);

  return (
    <div className={classNames(styles.play, { [styles.leaderboardPlay]: !onLeaderboard })}>
      <RegisteredPlayers {...{ isLiveRace, numOfPlayers }} />
      <div className={styles.playAction}>
        {!!onLeaderboard && (
          <div className={styles.expand}>
            <StarsButton
              variant="text"
              size="small"
              className={styles.cup}
              onClick={onLeaderboard}
              icon={<Cup />}
            />
          </div>
        )}
        <PlayButton race={race} onLeaderboard={onLeaderboard} onLaunch={onLaunch} />
      </div>
    </div>
  );
};

export default PlayBar;
